import { FunctionComponent } from 'react';
import classnames from 'classnames';

import StyledComponent from './styles';

const Component: FunctionComponent<any> = ({
    href,
    label,
    size,
    style,
    variant,
    layout
}) => {

    return (
        <StyledComponent
            className={classnames(
                'layout-button',
                `size-${size}`,
                `style-${style}`,
                `variant-${variant}`,
                `layout-${layout}`,
            )}
        >
            
            <a
                className="button"
                href={href}
                target="_new"
            >
                {label}
            </a>
        
        </StyledComponent>
    );
};

export default Component;